import React from "react";
import { Image } from "@catchoftheday/cg-components";
import { ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG, ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG_LANDSCAPE, } from "../../../consts";
import { useIsMobile } from "../../../hooks";
export const MigrationModalSideImage = () => {
    const isMobile = useIsMobile();
    return (<Image width={{
            xs: "100%",
            md: "auto",
        }} height={{
            xs: "auto",
            md: "100%",
        }} src={isMobile
            ? ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG_LANDSCAPE
            : ASSET_WOMAN_HANDS_UP_WITH_ONEPASS_LIGHT_BG} alt="Woman raising hands up in the air with OnePass background"/>);
};
